module.exports = __webpack_public_path__ + "img/gastroscope.c9887bb0.png";